const normalizeOption = (option) => {
  if (typeof option === "string") {
    return { key: option, label: option };
  }
  if (option && typeof option === "object") {
    const key = option.key || option.value || option.label;
    return { key: key ?? String(option), label: option.label || key || String(option) };
  }
  return { key: String(option), label: String(option) };
};

function FilterBar({ options = [], selected, onSelect, allowMultiple = false }) {
  const normalizedOptions = options.map(normalizeOption);
  const selectedSet = allowMultiple
    ? selected instanceof Set
      ? selected
      : new Set(Array.isArray(selected) ? selected : selected ? [selected] : [])
    : new Set(selected ? [selected] : []);

  const handleClick = (option, isActive) => {
    if (!onSelect) return;
    if (!allowMultiple) {
      onSelect(option);
      return;
    }
    const next = new Set(selectedSet);
    if (isActive) {
      next.delete(option);
    } else {
      next.add(option);
    }
    onSelect(Array.from(next));
  };

  return (
    <div className="filters">
      {normalizedOptions.map((option, idx) => {
        const isActive = allowMultiple
          ? selectedSet.has(option.key)
          : selected
            ? selectedSet.has(option.key)
            : idx === 0;
        return (
          <button
            key={option.key || option.label || idx}
            type="button"
            className={`filter-chip ${isActive ? "active" : ""}`}
            onClick={onSelect ? () => handleClick(option.key, isActive) : undefined}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default FilterBar;
